import { render, staticRenderFns } from "./CreatePromo.vue?vue&type=template&id=04769086"
import script from "./CreatePromo.vue?vue&type=script&lang=js"
export * from "./CreatePromo.vue?vue&type=script&lang=js"
import style0 from "./CreatePromo.vue?vue&type=style&index=0&id=04769086&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports